import React, { useEffect, useRef, useState } from "react";
import { useFilePicker } from "use-file-picker";
import {
  IonIcon,
  IonModal,
  IonButton,
  IonRow,
  IonCol,
  IonTextarea,
  IonActionSheet,
} from "@ionic/react";
import "./MediaUpload.scss";
import {
  addOutline,
  attach,
  camera,
  chevronBackOutline,
  close,
  image,
  imagesOutline,
  mic,
  videocam,
  videocamOutline,
} from "ionicons/icons";
import sanitizeHtml from "sanitize-html";
import MediaUploadCard from "./Components/MediaUploadCard/MediaUploadCard";
import _, { isEmpty } from "lodash";
import { utilService } from "../../../../services";
import { useHistory, useLocation } from "react-router";
import { CONSTANTS } from "../../../../constants";
import { ImageService } from "../ImageComponent/ImageComponent.service";
import { AudioService } from "../AudioComponent/AudioComponent.service";
import { MediaUploadService } from "./MediaUpload.service";
import { useToast } from "@agney/ir-toast";
import { VideoService } from "../VideoComponent/VideoComponent.service";
import VideoComponent from "../VideoComponent/VideoComponent";
import { dataTransferService } from "../../../../services/dataTransferService";
import Loader from "../../../../components/Shared/Loader/Loader";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import { usePhoto } from "../../../../hooks/usePhoto";
import { isPlatform } from "@ionic/core";
import { userMessageService } from "../../../UserMessages/UserMessage.service";
import AudioComponent from "../AudioComponent/AudioComponent";

// Megabytes. Matches the threshold this screen has always used; it is a
// client-side guard only, the server enforces its own limit.
const MAX_UPLOAD_SIZE_MB = 150;
declare const MediaRecorder: any;
declare const Recorder: any;

interface mediaUploadProps {
  isGroupMediaShare?: boolean;
  doctorListDataFromParent?: any;
  isNotificationCard?: boolean;
  isDoctorCardFileShare?: boolean;
  isShowNamesList?: boolean;
  isProviderCard?: boolean;
  dataFromParentComponent?: any;
  onOk: () => void;
  onCancel: () => void;
  patientId?: any;
  isStatusBoard?: boolean;
  isSmallScreen?: boolean;
  initValue?: any;
  isMessageComponent?: boolean;
  isUploadAttachment?: boolean;
  smsThread: any;
  selectedUsers?: any;
  isFromHomeMessage?: any;
}

const MediaUpload: React.FC<mediaUploadProps> = (props) => {
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isVideoRecording, setIsVideoRecording] = useState(false);
  const [isImageRecording, setIsImageRecording] = useState(false);
  const [isRoutedFromMediaList, setIsRoutedFromMediaList]: any =
    useState(false);
  const [mediaItem, setMediaItem]: any = useState([]);
  const [clientMediaID, setClientMediaID]: any = useState(Number);
  const [fileSize, setFileSize]: any = useState("");
  const [mediaType, setMediaType]: any = useState();
  const [mediaAction, setMediaAction]: any = useState();
  const [userMessage, setUserMessage]: any = useState("");
  const [selectedDoctorData, setSelectedDoctorDta]: any = useState([]);
  const [displayMediaList, setDisplayMediaList]: any = useState([]);
  var [showLoader, setShowLoader] = useState(false);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [isVideoDeviceAvailable, setIsVideoDeviceAvailable] = useState(false);
  const [viewAttachment, setViewAttachment] = useState(false);
  const [isMediaAttach, setMediaAttach] = useState(false);
  const [isAudioDeviceAvailable, setIsAudioDeviceAvailable] = useState(true);
  const [toggleAttachment, setToggleAttachment] = useState(false);
  const [timerIntervalID, setTimerIntervalID]: any = useState("");
  const [columnSize, setColumnSize]: any = useState("12");
  const [userTextMessage, setMessage]: any = useState("");
  const [disableMediaSection, setDisableMediaSection] = useState(false);
  const [disableAudioSection, setDisableAudioSection] = useState(false);
  const [isShowPopOver, setShowPopover] = useState(false);
  const [isShowNewPopOver, setShowNewPopover] = useState(false);
  const [isCaptureMediaPopOver, setIsCaptureMediaPopOver] = useState(false);
  const [isShowRecordMediaPopOver, setShowRecordMediaPopover] = useState(false);

  // audio picker package
  const [openFileSelector, { plainFiles }] = useFilePicker({
    accept: ".mp3,.wav,audio/",
  });

  let mediaUploadListLength = 0;

  let history = useHistory();
  const location: any = useLocation();
  const Toast = useToast();

  const [base64, setBase64] = useState("");

  const { takePhoto, photos } = usePhoto();

  useEffect(() => {
    setProfilePicture();
  }, [photos]);

  useEffect(() => {
    if (props.selectedUsers) {
      setMediaList();
    }
  }, [props.selectedUsers]);

  useEffect(() => {
    if (displayMediaList.length === 0) {
      setToggleAttachment(false);
      const mediaUploadTextBox = document.getElementById(
        "mediaMessageUploadTextBox"
      );

      let mediaUploadMessage = mediaUploadTextBox?.textContent;

      if (mediaUploadMessage) {
        setMessage("media message");
        setMediaAttach(false);
      } else {
        setMessage("");
      }
    } else if (displayMediaList.length > 0) {
      setMessage("media message");
    }
  }, [displayMediaList]);

  useEffect(() => {
    if (!_.isEmpty(plainFiles)) {
      const fileCollection: any = plainFiles;
      for (var index = 0; index < fileCollection.length; index++) {
        const fileData = fileCollection[index];
        const clientMediaID = Math.floor(Math.random() * 10000);
        setClientMediaID(clientMediaID);
        fileData["clientMediaID"] = clientMediaID;
        setNativeTemp(fileData, 2);
      }
      setShowPopover(false);
      setMediaAttach(true);
    }
  }, [plainFiles]);

  const setProfilePicture = () => {
    var initValueBase = props.initValue == null ? "" : props.initValue;
    var bSixtyFour = photos != undefined ? photos.base64 : initValueBase;
    setBase64(bSixtyFour);
    let imageFileName =
      "IMG-" + new Date().getMinutes() + new Date().getSeconds();
    if (!_.isEmpty(bSixtyFour)) {
      let imageFile: any = dataURLtoFile(bSixtyFour, imageFileName);
      const clientMediaID = Math.floor(Math.random() * 10000);
      setClientMediaID(clientMediaID);
      imageFile["clientMediaID"] = clientMediaID;
      setNativeTemp(imageFile, 1);
      setMediaAttach(true);
    }
  };

  const handleOnMediaBackClick = () => {
    setShowNewPopover(true);
    setShowPopover(false);
  };

  const dataURLtoFile = (dataurl: any, filename: any) => {
    var dataArray = dataurl.split(","),
      mime = dataArray[0].match(/:(.*?);/)[1],
      bstr = atob(dataArray[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  useEffect(() => {
    if (utilService.isWeb()) {
      if (props.selectedUsers.length > 1) {
        setVideoAndAudioDeviceStatus();
      } else {
        clearMediaFileArray();
      }
    }
    props.isSmallScreen ? setColumnSize("12") : setColumnSize("4");
    if (props.isMessageComponent) {
      setColumnSize("6");
    }
    return () => {
      dataTransferService.transferAudioMediaAction(false);
    };
  }, []);

  useEffect(() => {
    // if (utilService.isWeb() && showVideoUploadModal) {
    // if (showVideoUploadModal) {
      setVideoAndAudioDeviceStatus();
    // }
  }, []);

  const setVideoAndAudioDeviceStatus = () => {
    var localVideoStream: any;
    var localAudioStream: any;
    navigator.mediaDevices.getUserMedia(
      { video: true })
      .then(function (stream: { getTracks: () => any[] }) {
        setIsVideoDeviceAvailable(true);
        localVideoStream = stream;
        stream
          .getTracks()
          .forEach((track: { stop: () => any }) => track.stop());
      },
      function () {
        setIsVideoDeviceAvailable(false);
      }
    );

    if (localVideoStream) {
      localVideoStream.getTracks().forEach((track: any) => track.stop());
    }

    navigator.mediaDevices.getUserMedia(
      { audio: true })
      .then(function (stream: { getTracks: () => any[] }) {
        setIsAudioDeviceAvailable(true);
        localAudioStream = stream;
        stream
          .getTracks()
          .forEach((track: { stop: () => any }) => track.stop());
      },
      function () {
        setIsAudioDeviceAvailable(false);
      }
    );

    if (localAudioStream) {
      localAudioStream.getTracks().forEach((track: any) => track.stop());
    }
  };

  const showAudioErrorMessage = () => {
    Toast.error(CONSTANTS.MESSAGES.NO_AUDIO_DEVICE);
  };

  const setDoctorNamesArray = () => {
    var doctorNamesArray: any = [];
    if (!_.isEmpty(props.doctorListDataFromParent)) {
      props.doctorListDataFromParent.map((listItem: any) => {
        doctorNamesArray.push(listItem.firstName);
      });
      return doctorNamesArray.toString();
    }
  };

  useEffect(() => {
    checkIfSmallScreen();
    utilService.hideFooterTab();
    if (props.dataFromParentComponent) {
      setIsRoutedFromMediaList(
        props.dataFromParentComponent.isCalledFromMediaListComponent
      );
    }
    if (props.isGroupMediaShare === true) {
      setUiForGroupMediaShareModal();
      setSelectedDoctorDta(props.doctorListDataFromParent);
    } else if (props.isMessageComponent === true) {
      setSelectedDoctorDta(props.doctorListDataFromParent);
    }
    return () => {
      utilService.showFooterTab();
    };
  }, []);

  useEffect(() => {
    setSelectedDoctorDta(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/file-share/upload-media"
    ) {
      const currentLocation: any = location;
      setMediaItem(currentLocation.state.mediaItem);
      setIsRoutedFromMediaList(
        currentLocation.state.isCalledFromMediaListComponent
      );
      setSelectedDoctorDta(currentLocation.state.selectedDoctorData);
      setMediaAction(currentLocation.state.mediaAction);
    }
  }, [location]);

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
      utilService.hideFooterTab();
    } else {
      setIsSmallScreen(false);
    }
  };

  const clearMediaFileArray = () => {
    ImageService.displayImageList = [];
    ImageService.uploadImageList = [];
    AudioService.displayAudioList = [];
    AudioService.uploadAudioList = [];
    VideoService.displayVideoList = [];
    VideoService.uploadVideoList = [];
  };

  const setUiForGroupMediaShareModal = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    mediaListContainer?.style.setProperty("height", "220px");

    const mediaUploadTextBox = document.getElementById("media-upload-text-box");
    mediaUploadTextBox?.style.setProperty("width", "350px");
  };

  const openModalPopUp = (type: Number) => {
    setMediaType(type);
    setIsVideoRecording(false);
    if (utilService.isWeb()) {
      if(isVideoDeviceAvailable){
        setShowVideoUploadModal(true);
        setMediaAttach(true);
      }else{
        Toast.error("No media devices avialable")
      }
    } 
      dataTransferService.transferVideoMediaAction(!isVideoRecording);
    
  };

  const closeModalPopUp = (type: Number) => {
    setShowVideoUploadModal(false);
  };

  const onCardRemove = () => {
    setMediaList();
    setDisableMediaSection(false);
    setDisableAudioSection(false);
  };

  const setMediaList = () => {
    setDisableSendButton(false);

    const mediaList = [
      ...ImageService.displayImageList,
      ...AudioService.displayAudioList,
      ...VideoService.displayVideoList,
    ];

    setDisplayMediaList(_.cloneDeep([...mediaList]));
  };

  const webAttachMedia = (mediaType: any) => {
    let file: any = "";
    if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      file = document.getElementsByName("audio-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      file = document.getElementsByName("image-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.VIDEO) {
      file = document.getElementsByName("video-file")[0] as any;
    }
    const fileCollection: any = file.files;
    for (var index = 0; index < fileCollection.length; index++) {
      const fileData = fileCollection[index];
      const clientMediaID = Math.floor(Math.random() * 10000);
      setClientMediaID(clientMediaID);
      fileData["clientMediaID"] = clientMediaID;
      setNativeTemp(fileData, mediaType);
    }

    setMediaAttach(true);
  };

  const setNativeTemp = async (file: any, mediaType: any) => {
    const base64Data = (await convertBlobToBase64(file)) as string;
    const params = {
      name: file.name,
      nativeURL: base64Data,
      type: mediaType,
      isNative: false,
      clientMediaID: file.clientMediaID,
      size: utilService.formatBytes(file.size),
      isAttach: true,
    };
    storeToDisplayService(params, mediaType);
    setWebParams(file, mediaType);
  };

  const convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });

  const getBase64 = (file: any) => {
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);

    reader.onload = () => {
      // get the blob of the image:
      let blob: Blob = new Blob([new Uint8Array(reader.result as ArrayBuffer)]);

      // create blobURL, such that we could use it in an image element:
      let blobURL: string = URL.createObjectURL(blob);
      let sanitizedUrl = sanitizeHtml(blobURL);
      setFileSize(utilService.formatBytes(file.size));
      const params = {
        name: file.name,
        nativeURL: sanitizedUrl,
        type: mediaType,
        isNative: false,
        clientMediaID: file.clientMediaID,
        size: utilService.formatBytes(file.size),
        isAttach: true,
      };
      // storeToDisplayService(params);
      // setWebParams(file);
    };

    reader.onerror = (error) => {
      //handle errors
    };
  };

  const setWebParams = (fileData: any, mediaType: any) => {
    const params = {
      clientMediaID: fileData.clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: parseToGuidUsers(),
      message: "",
      type: mediaType,
      sms_thread_id: props.smsThread,
      action: mediaAction,
      name: fileData.name.replace(/\s/g, "_"),
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    if (mediaAction === CONSTANTS.MEDIA_ACTIONS.REPLY) {
      var replyParams = {
        clientMediaID: fileData.clientMediaID,
        from_guid: utilService.getLoggedUserGuid(),
        to_guid: parseToGuidUsers(),
        message: "",
        type: mediaType,
        sms_thread_id: props.smsThread,
        action: mediaAction,
        id: parseMediaId(),
        name: fileData.name.replace(/\s/g, "_"),
        file: fileData,
        size: utilService.formatBytes(fileData.size),
      };
      storeToUploadService(replyParams, mediaType);
    } else {
      storeToUploadService(params, mediaType);
    }
  };

  const parseToGuidUsers = () => {
    if (props.isNotificationCard) {
      if (!_.isEmpty(props.dataFromParentComponent)) {
        const initialArray: any = [];
        if (props.isStatusBoard) {
          initialArray.push(utilService.getLoggedUserGuid());
        } else {
          initialArray.push(props.dataFromParentComponent.selectedUserId);
        }
        return JSON.stringify(initialArray);
      } else {
        return JSON.stringify(selectedDoctorData);
      }
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.doctorListDataFromParent)
      );
    }
  };

  const parseMediaId = () => {
    if (!_.isEmpty(props.dataFromParentComponent)) {
      return props.dataFromParentComponent.mediaItem.id;
    } else {
      return mediaItem.id;
    }
  };

  const storeToDisplayService = (sanitizedUrl: any, mediaType: any) => {
    if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      ImageService.displayImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      AudioService.displayAudioList.push(sanitizedUrl);
    } else {
      VideoService.displayVideoList.push(sanitizedUrl);
    }
    setMediaList();
  };

  const storeToUploadService = (sanitizedUrl: any, mediaType: any) => {
    sanitizedUrl.type = mediaType;
    if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      ImageService.uploadImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      AudioService.uploadAudioList.push(sanitizedUrl);
    } else {
      VideoService.uploadVideoList.push(sanitizedUrl);
    }
  };

  const sendMedia = () => {
    var mediaUploadMessage: any = "";
    const mediaUploadTextBox = document.getElementById(
      "mediaMessageUploadTextBox"
    );
    if (mediaUploadTextBox) {
      mediaUploadMessage = mediaUploadTextBox.textContent;
      setUserMessage(mediaUploadMessage);
    }

    if (isMediaAttach) {
      setParams(mediaUploadMessage);
    } else {
      replayAllMessage(mediaUploadMessage);
    }
  };

  async function replayAllMessage(messages: any) {
    setShowLoader(true);
    const params = setAllReplyParams(messages);
    displayMediaList.length = 0;
    const respReplyAllListResult: any =
      await userMessageService.setReplyAllData(params);
    if (respReplyAllListResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.GROUP_SMS_SUCCESS);
      onCancelRequest();
      var mediaUploadMessage: any = "";
      const mediaUploadTextBox = document.getElementById("mediaUploadTextBox");
      if (mediaUploadTextBox) {
        mediaUploadTextBox.textContent = "";
      }
    } else {
    }
    setShowLoader(false);
  }

  const setAllReplyParams = (messages: any) => {
    let selectedUsersGuid: any = [];
    if (props.doctorListDataFromParent) {
      props.doctorListDataFromParent.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    } else {
      props.doctorListDataFromParent.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    }
    if (!_.isEmpty(messages)) {
      return {
        message_sms: messages,
        reg_code: utilService.getNetwork(),
        time: utilService.getCurrentDateAndTime(),
        users: selectedUsersGuid,
        sms_thread_id: getSMSThreadId(),
      };
    }
  };

  const getSMSThreadId = () => {
    if (props.smsThread) {
      return props.smsThread;
    } else if (location?.state?.msgData?.sms_thread_id) {
      return location?.state?.msgData.sms_thread_id;
    }
  };

  const setParams = (mediaUploadMessage: any) => {
    const uploadMediaList = [
      ...ImageService.uploadImageList,
      ...AudioService.uploadAudioList,
      ...VideoService.uploadVideoList,
    ];
    uploadMediaList.forEach((element: any) => {
      element.message = mediaUploadMessage;
      element.reg_code = utilService.getNetwork();
      if (_.isEmpty(mediaAction)) {
        element.action = 1;
      }
      if (props.patientId) {
        element.pid = props.patientId;
      }
      if (mediaAction === CONSTANTS.MEDIA_ACTIONS.REPLY) {
        element.action = mediaAction;
        element.id = parseMediaId();
      }

      if (!_.isEmpty(props.dataFromParentComponent)) {
        element.action = props.dataFromParentComponent.mediaAction;
        element.id = parseMediaId();
      }

      const media = {
        mediaData: element,
        uploadMediaList: uploadMediaList,
      };
      // element.size is megabytes (utilService.formatBytes divides by 1024^2).
      if (MAX_UPLOAD_SIZE_MB < Number(element.size)) {
        ifSizeIsLarge(element);
      } else {
        uploadMedia(media);
      }
    });
  };

  const uploadMedia = async (params: any) => {
    setShowLoader(true);
    const formData = utilService.constructFormData(params.mediaData);
    const respFileShareMediaListResult: any =
      await MediaUploadService.mediaUpload(formData);
    mediaUploadListLength = mediaUploadListLength + 1;
    if (respFileShareMediaListResult.isSuccess) {
      clearUploadedServiceMediaList(params.mediaData);
    } else {
    }
    if (mediaUploadListLength === params.uploadMediaList.length) {
      mediaUploadListLength = 0;
      setShowLoader(false);
      Toast.success(CONSTANTS.MESSAGES.MEDIA_UPLOAD_SUCCESS);
      onCancelRequest();
      clearStoredServiceMediaList();
      //clear typed message after uploaded media
      const mediaUploadTextBox = document.getElementById("mediaUploadTextBox");
      if (mediaUploadTextBox) {
        mediaUploadTextBox.textContent = "";
      }
      setDisableSendButton(true);
    }
  };

  const clearUploadedServiceMediaList = (mediaData: any) => {
    const deleteStyle = document.getElementById(
      `media-${mediaData.clientMediaID}`
    );
    deleteStyle?.style.setProperty("display", "none");
    switch (mediaData.type) {
      case 1:
        _.remove(ImageService.uploadImageList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
      case 2:
        _.remove(AudioService.uploadAudioList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
      case 3:
        _.remove(VideoService.uploadVideoList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
    }
  };

  const onCancelRequest = () => {
    let largeScreen = utilService.getScreenSize() === "large";
    let smallScreen = utilService.getScreenSize() === "small";
    let isOnCancelAvailable = "onCancel" in props;

    if (smallScreen) {
      history.goBack();
    } else if (largeScreen && isOnCancelAvailable) {
      props.onCancel();
    } else {
      history.goBack();
    }
    // setSearchText("");
  };

  const viewMediaAttachment = () => {
    setViewAttachment(true);
    setToggleAttachment(true);
    setDisableMediaSection(true);
    setDisableAudioSection(true);
  };

  const clearStoredServiceMediaList = () => {
    clearMediaFileArrayUploads();
    setMessage("");
  };

  const clearMediaFileArrayUploads = () => {
    setDisplayMediaList((ImageService.displayImageList = []));
    setDisplayMediaList((ImageService.uploadImageList = []));
    setDisplayMediaList((AudioService.displayAudioList = []));
    setDisplayMediaList((AudioService.uploadAudioList = []));
    setDisplayMediaList((VideoService.displayVideoList = []));
    setDisplayMediaList((VideoService.uploadVideoList = []));
  };

  // Every line of this was commented out, so a file over the limit was neither
  // uploaded nor reported: it just vanished, and the sender believed it had
  // been sent. Say so instead.
  const ifSizeIsLarge = (mediaData: any) => {
    const sizeInMb = Number(mediaData?.size);
    const sizeText = Number.isFinite(sizeInMb) ? `${sizeInMb.toFixed(1)} MB` : "";
    Toast.error(
      `${mediaData?.name ? `"${mediaData.name}" ` : "That file "}is too large to send` +
        `${sizeText ? ` (${sizeText})` : ""}. The limit is ${MAX_UPLOAD_SIZE_MB} MB.`
    );
  };

  const onAudioRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.AUDIO);
    if (utilService.isWeb()) {
      setIsRecording(!isRecording);
      setAudioRecordCss(!isRecording);
      // setDisableMediaSection(!isRecording);
      if (!isRecording) {
        startAudioTimer();
        setMediaAttach(true);
      }
      if (isRecording) {
        stopTimerInUI();
      }
    }
    dataTransferService.transferAudioMediaAction(!isRecording);
  };

  const onImageRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.IMAGE);
    setIsImageRecording(!isImageRecording);
    setMediaAttach(true);
    dataTransferService.transferImageMediaAction(!isImageRecording);
  };

  const onComplete = (mediaType: Number) => {
    setMediaList();
    closeModalPopUp(mediaType);
  };

  const setMessageInput = (message: any) => {
    setMessage(message);
  };

  const startAudioTimer = () => {
    const minsEle: any = document.querySelector(".mins");
    const secEle: any = document.querySelector(".sec");
    showTimerInUI(minsEle, secEle);
  };

  const setAudioRecordCss = (status: Boolean) => {
    const recDiv: any = document.getElementById("recButton");
    showRecordForMedia(recDiv, status);
  };

  const showTimerInUI = (minute: any, seconds: any) => {
    const startTime: any = new Date();
    let duration = 0;
    let stopTime = 0;
    const timer: any = setInterval(() => {
      let currTime: any = new Date();
      duration = stopTime + (currTime - startTime) / 1000;
      minute.innerHTML = (duration / 60) << 0;
      seconds.innerHTML = duration % 60 << 0;
    }, 10);

    setTimerIntervalID(timer);
  };

  const stopTimerInUI = () => {
    const minute: any = document.querySelector(".mins");
    const seconds: any = document.querySelector(".sec");
    minute.innerHTML = "";
    seconds.innerHTML = "";
    clearInterval(timerIntervalID);
  };

  const showRecordForMedia = (recordDiv: any, status: any) => {
    recordDiv.classList.add("notRec");
    if (status) {
      recordDiv.classList.add("Rec");
    } else {
      recordDiv.classList.add("notRec");
      recordDiv.classList.remove("Rec");
    }
  };

  const mapProviderName = () => {
    var providerName = "";
    if (!props.isProviderCard) {
      providerName =
        props.doctorListDataFromParent[0].firstName +
        " " +
        props.doctorListDataFromParent[0].lastName;
    } else {
      providerName =
        props.doctorListDataFromParent[0].first_name +
        " " +
        props.doctorListDataFromParent[0].last_name;
    }
    return providerName;
  };
  const handleOnFocusForIos = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    if (mediaListContainer && isPlatform("ios") && isSmallScreen) {
      mediaListContainer.style.setProperty("height", "29vh", "important");
    }
  };

  const handleOnBlurForIos = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    if (mediaListContainer && isPlatform("ios") && isSmallScreen) {
      mediaListContainer.style.setProperty("height", "57vh", "important");
    }
  };

  const handleOnBackClick = () => {
    if (props.doctorListDataFromParent || props.isMessageComponent) {
      props.onCancel();
    } else {
      if (location.state.isFromFileShareMainPage) {
        history.push({
          pathname: "/client/file-share",
          state: { sendBtnStatus: location.state.isSentButtonClicked },
        });
      } else {
        history.goBack();
      }
    }
  };

  const [isVideoActionSheetOpen,setIsVideoActionSheetOpen] = useState<boolean>(false)
  const [isAudioActionSheetOpen,setIsAudioActionSheetOpen] = useState<boolean>(false)
  const attachVideoInputRef:any = useRef()

  return (
    <div>
      {viewAttachment && (
        <div
          className={`attachment-popover ${
            toggleAttachment ? "show-popover" : "hide-popover"
          }
          ${props.isFromHomeMessage ? "adjust-height-attachment" : ""} 
          `}
        >
          <div
            className="close-icon-attachment"
            onClick={() => {
              setToggleAttachment(false);
              setDisableMediaSection(false);
              setDisableAudioSection(false);
            }}
          >
            <IonIcon icon={close}></IonIcon>
          </div>

          <div
            className={`uploaded-media-list-container ${
              props.isGroupMediaShare ? "uploaded-media-list-height" : ""
            }`}
            id="uploaded-media-list-container"
          >
            <IonRow>
              {!_.isEmpty(displayMediaList) &&
                displayMediaList.map((item: any) => {
                  return (
                    <IonCol
                      className={`media-upload-card-col-${item.clientMediaID}`}
                      size-lg={columnSize}
                      size="12"
                    >
                      <MediaUploadCard
                        mediaItem={item}
                        onCardRemove={onCardRemove}
                      ></MediaUploadCard>
                    </IonCol>
                  );
                })}
            </IonRow>
          </div>
        </div>
      )}

      {showLoader && (
        <div
          className={`loader-div ${
            props.isGroupMediaShare ? "uploaded-message-media-loader-div" : ""
          }
              ${props.isFromHomeMessage ? "adjust-loader-container" : ""}`}
        >
          <Loader></Loader>
        </div>
      )}

      <div className="msg-media-upload-main-container">
        {/* <div className="message-main-container"> */}
        {/* {isMediaAttach && ( */}

        <div className="attachment-btn-container">
          <div
            className={`rec-audio-button-wrapper clickable ${
              isRecording ? "show-rec-wrapper" : "hide-rec-wrapper"
            }`}
            onClick={() => {
              isAudioDeviceAvailable
                ? onAudioRecBtnClick()
                : showAudioErrorMessage();
            }}
          >
            <div className="rec-btn-div">
              <button id="recButton"></button>
            </div>
            <div className="timer-div">
              <span className="mins">0</span>
              <span className="divider">:</span>
              <span className="sec">0</span>
            </div>
          </div>
          <AudioComponent
            onComplete={() => {
              onComplete(CONSTANTS.MEDIA_TYPE.AUDIO);
            }}
            selectedDoctorData={selectedDoctorData}
            isStatusBoard={props.isStatusBoard}
            smsThread={getSMSThreadId()}
          ></AudioComponent>
          <IonButton
            className="submit-btn button attached-media primary-btn btn-curved"
            onClick={() => {
              viewMediaAttachment();
            }}
            disabled={displayMediaList.length === 0}
          >
            Attachment : {displayMediaList.length}
          </IonButton>
        </div>
        {/* <div className=""> */}
        <div
          className={`add-media-icon-div ${
            disableMediaSection ? "disable-form-section" : ""
          }`}
        >
          <div className="add-media-icon" title="Attach Media">
            <div
              className={`input-icon ${
                isShowNewPopOver ||
                isCaptureMediaPopOver ||
                isShowPopOver === true
                  ? "disabled-input-icon"
                  : ""
              }`}
              onClick={() => {
                setShowNewPopover(true);
              }}
            >
              <IonIcon icon={attach} className="media-upload-icon"></IonIcon>
            </div>
            <div
              className={`new-popover-attach-media ${
                isShowNewPopOver
                  ? "show-message-popover"
                  : "hide-message-popover"
              }`}
            >
              <div
                onClick={() => {
                  setShowNewPopover(false);
                }}
                className="close-icon"
              >
                <IonIcon icon={close}></IonIcon>
              </div>
              {/* <div className="attach-media-icons-wrapper">
                <div
                  className="add-media-icon mr-3"
                  title="Attach from gallery"
                >
                  <div
                    className="input-icon"
                    onClick={() => {
                      setShowNewPopover(false);
                      setShowPopover(true);
                    }}
                  >
                    <IonIcon
                      icon={image}
                      className="media-upload-icon"
                    ></IonIcon>
                  </div>
                </div>

                <div className="add-media-icon" title="Capture Media">
                  <div
                    className="input-icon"
                    onClick={() => {
                      setShowNewPopover(false);
                      setIsCaptureMediaPopOver(true);
                    }}
                  >
                    <IonIcon
                      icon={addOutline}
                      className="media-upload-icon"
                    ></IonIcon>
                  </div>
                </div>
              </div> */}
            </div>
            <div
              className={`add-media-icon-div ${
                disableMediaSection ? "disable-form-section" : ""
              }`}
              onClick={(e: any) => {
                // setShowPopover(!isShowPopOver);
                setShowRecordMediaPopover(false);
              }}
            >
              <div
                className={`add-file-attach-media ${
                  isShowPopOver ? "show-popover" : "hide-popover"
                }`}
              >
                <div
                  className="back-icon"
                  onClick={() => {
                    handleOnMediaBackClick();
                  }}
                >
                  <IonIcon icon={chevronBackOutline} />
                </div>
                <div
                  className="close-icon"
                  onClick={() => setShowPopover(false)}
                >
                  <IonIcon icon={close}></IonIcon>
                </div>
                <div className="attach-media-icons-wrapper">
                  <div className="add-media-icon-div">
                    <div
                      className="add-media-icon icon-video-section"
                      onClick={() => setShowPopover(false)}
                    >
                      <input
                        ref={attachVideoInputRef}
                        id="file"
                        style={{
                          opacity: "0",
                        }}
                        multiple
                        name="video-file"
                        accept="video/mp4,video/x-m4v,video/*"
                        type="file"
                        value=""
                        onChange={() =>
                          webAttachMedia(CONSTANTS.MEDIA_TYPE.VIDEO)
                        }
                      />
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={videocamOutline}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Video</div>
                    </div>
                  </div>
                  <div className="add-media-icon-div">
                    <div
                      className="add-media-icon icon-audio-div"
                      onClick={() => {
                        setShowPopover(false);
                        openFileSelector();
                      }}
                    >
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={mic}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Audio</div>
                    </div>
                  </div>
                  <div
                    className="add-media-icon-div"
                    onClick={() => setShowPopover(false)}
                  >
                    <div className="add-media-icon icon-image-section">
                      <input
                        id="file"
                        style={{
                          opacity: "0",
                        }}
                        multiple
                        name="image-file"
                        accept="image/*"
                        type="file"
                        value=""
                        onChange={() => {
                          webAttachMedia(CONSTANTS.MEDIA_TYPE.IMAGE);
                        }}
                      />
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={imagesOutline}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Image</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="record-media-icon-div"
              onClick={(e: any) => {
                setShowRecordMediaPopover(!isShowRecordMediaPopOver);
                setShowPopover(false);
              }}
            >
              <div
                className={`capture-media ${
                  isShowNewPopOver ? "show-popover" : "hide-popover"
                }`}
              >
                {/* <div
                  className="back-icon"
                  onClick={() => {
                    setIsCaptureMediaPopOver(false);
                    setShowNewPopover(true);
                  }}
                >
                  <IonIcon icon={chevronBackOutline} />
                </div> */}
                <div
                  onClick={() => {
                    setShowNewPopover(false);
                    setIsCaptureMediaPopOver(false);
                  }}
                  className="close-icon"
                >
                  <IonIcon icon={close}></IonIcon>
                </div>
                <div className="attach-media-icons-wrapper">
                  <div className="add-media-icon-div">
                    <div
                      className="add-media-icon icon-video-section"
                      onClick={(e: any) => {
                        // openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO);
                        setIsVideoActionSheetOpen(true)
                        setShowNewPopover(false);
                        setIsCaptureMediaPopOver(false);
                      }}
                    >
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={videocam}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Video</div>
                    </div>
                  </div>
                  <IonActionSheet
                    isOpen={isVideoActionSheetOpen}
                    header="Video"
                    onDidDismiss={({ detail }) =>{
                      if(detail?.data?.action === "upload"){
                        attachVideoInputRef?.current?.click()
                        // webAttachMedia(CONSTANTS.MEDIA_TYPE.VIDEO)
                      }else if(detail?.data?.action === "record"){
                        openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO)
                      }
                      setIsVideoActionSheetOpen(false)
                    }}
                    buttons={[
                      {
                        text: "From videos",
                        data: {
                          action: "upload",
                        },
                      },
                      {
                        text: "Record video",
                        data: {
                          action: "record",
                        },
                      },
                      {
                        text: "Cancel",
                        role: "cancel",
                        data: {
                          action: "cancel",
                        },
                      },
                    ]}
                  ></IonActionSheet>
                  <div className="add-media-icon-div">
                    <div
                      className="add-media-icon icon-audio-div"
                      onClick={() => {
                        setShowNewPopover(false);
                        setIsCaptureMediaPopOver(false);
                        // onAudioRecBtnClick();
                        setIsAudioActionSheetOpen(true)
                      }}
                    >
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={mic}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Audio</div>
                    </div>
                  </div>
                  <IonActionSheet
                    isOpen={isAudioActionSheetOpen}
                    header="Audio"
                    onDidDismiss={({ detail }) =>{
                      if(detail?.data?.action === "upload"){
                        openFileSelector()
                      }else if(detail?.data?.action === "record"){
                        onAudioRecBtnClick();
                      }
                      setIsAudioActionSheetOpen(false)
                    }}
                    buttons={[
                      {
                        text: "From audios",
                        data: {
                          action: "upload",
                        },
                      },
                      {
                        text: "Record audio",
                        data: {
                          action: "record",
                        },
                      },
                      {
                        text: "Cancel",
                        role: "cancel",
                        data: {
                          action: "cancel",
                        },
                      },
                    ]}
                  ></IonActionSheet>
                  <div className="add-media-icon-div">
                    <div
                      className="add-media-icon icon-image-section"
                      onClick={()=>{
                        setShowNewPopover(false);
                        setIsCaptureMediaPopOver(false);
                        takePhoto()
                      }}
                    >
                      <div className="input-icon icon-div">
                        <IonIcon
                          icon={camera}
                          className="media-upload-icon"
                        ></IonIcon>
                      </div>
                      <div className="media-label">Image</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`comment-box ${
              props.isFromHomeMessage ? "adjust-text-area-width" : ""
            }
            ${disableMediaSection ? "disable-form-section" : ""}
            ${isRecording ? "hide-media-upload-text-box" : ""}`}
          >
            <IonTextarea
              className="textarea-div"
              maxlength={250}
              placeholder="Please enter your message here (Maximum 250 characters)"
              onFocus={handleOnFocusForIos}
              onBlur={handleOnBlurForIos}
              onIonChange={(e) => {
                setMessageInput(e.detail.value);
              }}
              id="mediaMessageUploadTextBox"
            ></IonTextarea>
          </div>
        </div>
        {/* </div> */}
        <div
          className={`group-sms-button-container ${
            toggleAttachment ? "group-button-disabled" : ""
          }
            `}
        >
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className={`button secondary-btn  btn-curved ${
                disableMediaSection ? "disable-form-section" : ""
              }`}
              onClick={() => {
                onCancelRequest();
              }}
            >
              Cancel
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              className={`submit-btn button primary-btn btn-curved ${
                disableMediaSection ? "disable-form-section" : ""
              }`}
              onClick={() => {
                sendMedia();
              }}
              disabled={
                isEmpty(userTextMessage) || props.selectedUsers.length === 0
              }
            >
              Send
            </IonButton>
          </div>
        </div>
        {/* </div> */}
      </div>

      <IonModal
        isOpen={showVideoUploadModal}
        backdropDismiss={false}
        className="audio-upload-modal video-upload-modal"
      >
        <div
          className="close-icon"
          onClick={() => {
            setShowVideoUploadModal(false);
            setMediaList();
          }}
        >
          <IonIcon icon={close}></IonIcon>
        </div>
        <VideoComponent
          onComplete={() => {
            onComplete(CONSTANTS.MEDIA_TYPE.VIDEO);
          }}
          selectedDoctorData={selectedDoctorData}
          isStatusBoard={props.isStatusBoard}
          smsThread={props.smsThread}
        ></VideoComponent>
      </IonModal>
    </div>
  );
};

export default MediaUpload;
